import React from "react";
import PropTypes from "prop-types";
import Headline from "../Typography/Headline";
import ClimateDetails from "../ClimateDetails";
import CategoryItems from "../CategoryItems";
import i18n from "~/assets/js/Helpers/i18n";
import Tagline from "../Tagline";
// import GreenClubCapacityPopUp from "../GreenClub/GreenClubCapacityPopUp";
import GreenClubLowerPrice from "../GreenClub/GreenClubLowerPrice";
import { formatPrice } from "../../Format";

/**
 * Displays basic information about the product
 * Title, price, Env specs, categories
 * @returns JSX component
 */
const ProductInfo = ({
    isMainDish,
    title,
    price,
    taxRate,
    attr,
    details,
    discounted,
    discountedPrice,
    wasPrice,
}) => {
    const tags = attr.map((attribute) => attribute.slug);
    const { iconPath } = reactConfig;

    return (
        <div id="product-info">
            {isMainDish && (
                <Tagline
                    iconUrl={`${iconPath}/sapling.svg`}
                    label={
                        details.product_detail_notice ||
                        "productDetails.productDetailNotice"
                    }
                />
            )}
            <Headline className="title" size={5} resizable>
                {title}
            </Headline>
            {discounted && isMainDish ? (
                <GreenClubLowerPrice
                    newPrice={discountedPrice}
                    oldPrice={
                        wasPrice && wasPrice < parseFloat(price)
                            ? formatPrice(wasPrice)
                            : price
                    }
                    taxRate={i18n.t("productInfo.taxRate", { rate: taxRate })}
                />
            ) : (
                <GreenClubLowerPrice
                    newPrice={price}
                    oldPrice={
                        wasPrice &&
                        parseFloat(wasPrice) > parseFloat(price) &&
                        formatPrice(wasPrice)
                    }
                    isGreenClub={false}
                    taxRate={i18n.t("productInfo.taxRate", { rate: taxRate })}
                />
            )}
            <div className="row">
                <ClimateDetails climateDetails={details} />
            </div>
            <div className="row">
                <CategoryItems tags={tags} />
            </div>
        </div>
    );
};

ProductInfo.propTypes = {
    isMainDish: PropTypes.bool,
    title: PropTypes.string,
    price: PropTypes.string,
    taxRate: PropTypes.string,
    discounted: PropTypes.bool,
    discountedPrice: PropTypes.string,
    attr: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            slug: PropTypes.string,
        })
    ),
    details: PropTypes.shape({
        co2: PropTypes.number,
        water: PropTypes.number,
        energy: PropTypes.number,
        product_detail_notice: PropTypes.string,
    }),
};

export default ProductInfo;
